// extracted by mini-css-extract-plugin
module.exports = {"LogoImage":"styles_LogoImage__gt1Jb"};